import { createContext, useContext } from "react";

export const orderFlowCloseReason = {
  changePostCodeOrLocation: "change-postcode-or-location"
}
export type OrderFlowCloseReason = "change-postcode-or-location"

export type OrderFlowData = {
  handleBack: () => any,
  handleContinue: () => any,
  handleClose: (reason?: string) => any
}

export const OrderFlowContext = createContext<OrderFlowData>({
  handleBack: () => { },
  handleContinue: () => { },
  handleClose: () => { }
});

export const useOrderFlowContext = () => useContext(OrderFlowContext);
